import React, { useEffect, useState } from 'react';
import DealBannerForm from './form';
import ListDealBanners from './list';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDealBanners } from '../../../../store/slices/bannerSlice';
import { Button, message } from 'antd';
import { deleteDealBanner } from '../../../../api/banner';

const DealBanners = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [render, setRender] = useState(false);
  const [defaultValues, setDefaultValues] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const bannerData = useSelector((state) => state.banner);

  const getDealBannerData = async () => {
    dispatch(fetchDealBanners());
  };

  const onEditHandle = async (event) => {
    setDefaultValues(event);
    setShowForm(true);
    setIsEdit(true);
  };

  const onDeleteHandle = async (event) => {
    const deletedBanner = await deleteDealBanner(event._id);
    if(deletedBanner)
    {
      setRender(!render);
      message.success("Deal Banner Deleted Successfully!");
    }
  };

  useEffect(() => {
    getDealBannerData();
  }, [isEdit, showForm, render]);
  return (
    <div>
      <div className="flex justify-end w-full">
        <Button
          onClick={() => {
            if (!isEdit) {
              setDefaultValues({});
            }
            setShowForm(!showForm);
            setIsEdit(false);
          }}
        >
          {showForm ? 'Cancel' : ' Add New Banner'}
        </Button>
      </div>
      {showForm ? (
        <DealBannerForm
          defaultValues={defaultValues}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          setShowForm={setShowForm}
        />
      ) : bannerData?.response && bannerData?.response?.length ? (
        <ListDealBanners
          bannerData={bannerData?.response}
          isLoading={bannerData?.isLoading}
          onEdit={onEditHandle}
          onDelete={onDeleteHandle}
        />
      ) : (
        <div className="px-2 border mt-2 border-solid border-black w-full flex items-center justify-center">
          <p className="w-full">
            You don't have any Deal Banner set up right now
          </p>
        </div>
      )}
    </div>
  );
};

export default DealBanners;
